import { z } from 'zod';
import { SweetShopArticleModelSchema } from 'entities/sweet-shop-article';
import { GetSweetShopArticlesByCategoryUidAndTagUidApiResponseSchema } from '../store';

export const createSweetShopArticlesFromGetSweetShopArticlesByCategoryUidAndTagUidApiResponse = (
    (response: z.infer< typeof GetSweetShopArticlesByCategoryUidAndTagUidApiResponseSchema>) => (
        response.data?.map(({
            slug,
            name,
            description,
            category,
            images,
            tags,
            price,
            weight,
            currency,
        }) => (
            SweetShopArticleModelSchema.parse({
                uid: slug,
                name,
                description,
                category: category && {
                    uid: category.slug,
                },
                tags: tags?.map(({ slug: slug2 }) => ({
                    uid: slug2,
                })),
                images: images?.map(({ url }) => ({
                    url,
                })),
                price,
                weight,
                currency,
            })
        ))
    )
);
